import useGeoInfo from "./useGeoInfo";

export default useGeoInfo;